import axios from "../services/api/api";
import { useQuery } from "@tanstack/react-query";

const FetchStudentCourses = async () => {
  const res = await axios.get("/student/MyCourses");
  return res.data.result;
};

export function GetStudentCourses() {
  return useQuery({
    queryKey: ["FetchStudentCourses"],
    queryFn: () => FetchStudentCourses(),
    retry: 3,
  });
}

const FetchStudentResults = async () => {
  const res = await axios.get("/student/MyResults");
  return res.data.result;
};

export function GetStudentResults() {
  return useQuery({
    queryKey: ["FetchStudentResults"],
    queryFn: () => FetchStudentResults(),
    retry: 3,
  });
}

const FetchStudentProfile = async () => {
  const res = await axios.get("/student/MyResult");
  return res.data.result;
};

export function GetStudentProfile() {
  return useQuery({
    queryKey: ["FetchStudentProfile"],
    queryFn: () => FetchStudentProfile(),
    retry: 3,
  });
}
